import { gql } from '@apollo/client'

export const getEnrichmentTypes = gql`
  query {
    getEnrichmentsTypes {
      enrichmentTypes {
        id
        name
        naturalKey
        downloadableTypes {
          id
          name
          naturalKey
        }
      }
    }
  }
`

export const getTemplateByEnrichment = gql`
  query getTemplateByEnrichment($enrichmentTypeId: Int!) {
    getTemplateByEnrichment(enrichmentTypeId: $enrichmentTypeId) {
      encodedFile
      fileName
      mimeType
    }
  }
`

export const processExcelFile = gql`
  mutation processExcelFile($file64: String!, $enrichmentTypeId: Int!) {
    processExcelFile(file64: $file64, enrichmentTypeId: $enrichmentTypeId) {
      ... on ProcessExcelSuccess {
        rutsA
        rutsB
      }
    }
  }
`

export const createProcess = gql`
  mutation createProcess(
    $clientName: String!
    $name: String!
    $downloadableTypeIds: [Int!]!
    $enrichmentTypeId: Int!
    $shouldProcess: Boolean!
    $rutsA: [String!]!
    $rutsB: [String!]
    $levelA: Int
    $levelB: Int
  ) {
    createProcess(
      clientName: $clientName
      name: $name
      downloadableTypeIds: $downloadableTypeIds
      enrichmentTypeId: $enrichmentTypeId
      shouldProcess: $shouldProcess
      rutsA: $rutsA
      rutsB: $rutsB
      levelA: $levelA
      levelB: $levelB
    )
  }
`

export const editProcess = gql`
  mutation editProcess(
    $processUuid: UUID!
    $clientName: String!
    $name: String!
    $downloadableTypeIds: [Int!]!
    $enrichmentTypeId: Int!
    $shouldProcess: Boolean!
    $rutsA: [String!]!
    $rutsB: [String!]
    $levelA: Int
    $levelB: Int
  ) {
    editProcess(
      processUuid: $processUuid
      clientName: $clientName
      name: $name
      downloadableTypeIds: $downloadableTypeIds
      enrichmentTypeId: $enrichmentTypeId
      shouldProcess: $shouldProcess
      rutsA: $rutsA
      rutsB: $rutsB
      levelA: $levelA
      levelB: $levelB
    )
  }
`

export const getProcessesPaginated = gql`
  query getProcessesPaginated(
    $page: Int
    $pageSize: Int = 10
    $orderBy: String = "-id"
    $filters: ProcessFilters
  ) {
    getProcessesPaginated(page: $page, pageSize: $pageSize, orderBy: $orderBy, filters: $filters) {
      processes {
        uuid
        name
        clientName
        createdAt
        state {
          name
        }
        data {
          enrichmentType {
            name
          }
        }
      }
      pageMeta {
        page
        pageSize
        totalCount
        totalPages
      }
    }
  }
`

export const getProcessStates = gql`
  query {
    getProcessStates {
      id
      name
      naturalKey
    }
  }
`

export const downloadFileFromProcess = gql`
  query DownloadFileFromProcess($processUuid: UUID!) {
    downloadFileFromProcess(processUuid: $processUuid) {
      encodedFile
      fileName
      mimeType
    }
  }
`

export const getProcessOutputs = gql`
  query GetProcessOutputs($processUuid: UUID!) {
    getProcessOutputs(processUuid: $processUuid) {
      id
      downloadableType {
        id
        name
        naturalKey
      }
      mimeType
      filename
    }
  }
`

export const downloadProcessOutput = gql`
  query DownloadProcessOutput($processUuid: UUID!, $downloadableTypeNk: String!) {
    downloadProcessOutput(processUuid: $processUuid, downloadableTypeNk: $downloadableTypeNk) {
      encodedFile
      fileName
      mimeType
    }
  }
`

export const getProcess = gql`
  query getProcess($uuid: UUID!) {
    getProcess(uuid: $uuid) {
      process {
        uuid
        name
        clientName
        createdAt
        downloadableType {
          id
          name
        }
        data {
          enrichmentType {
            id
            name
          }
          rutsA
          rutsB
          levelA
          levelB
          requestedDownloadableTypeIds
        }
      }
    }
  }
`
